import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import {
  SetCoachingCapacity,
  SetCoachingCapacityError,
} from "./CoachingCapatityActions";
import { useParams, useLocation } from "react-router";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function CoachingCapacity(props) {
  const dispatch = useDispatch();

  const {
    role,
    overall_number_of_coaching_assignments,
    current_number_of_assignments,
    current_capacity,
    available_to_take_new_assignments,
    date_available_from,
    date_available_until,
  } = useSelector((state) => state.coachingCapacityReducer.data);

  const errors = useSelector((state) => state.coachingCapacityReducer.errors);

  const {
    expertise_areas,
    diagnostic_tools,
    // industry_sector_lists,
    // disciplines,
    language_lists,
    client_types,
    function_lists,
    country_lists,
    cli_expertises,
  } = useSelector((state) => state.commonReducer.employeeDropdowns);

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    console.log(`object`, value, index, type);
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      if (item.value || item.inputValue || item.selectValue) {
        item.value && (formData[item.name] = item.value);
        item.inputValue && (formData[item.inputName] = item.inputValue);
        item.selectValue && (formData[item.selectName] = item.selectValue);
        dispatch(SetCoachingCapacity(formData));
      }
    });
    dispatch(SetCoachingCapacityError(updatedForm[index].name));
  };
  // Form disabling
  const location = useLocation();
  const globaluserData = useSelector((state) => state.commonReducer);

  const organisation_id = globaluserData?.organisation_id;
  const employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    role === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };

  const formArray = [
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Job Title*",
    //   // helperText: errors.role && "Please enter a job role",
    //   name: "role",
    //   placeholder: "Job Role",
    //   handleChange: handleInputChange,
    //   value: "Coaching",
    // },
    {
      componentType: "input",
      type: "number",
      label:
        "What's the overall number of coaching assignments you can take on?",

      name: "overall_number_of_coaching_assignments",
      placeholder:
        "What's the overall number of coaching assignments you can take on?",
      handleChange: handleInputChange,
      value: overall_number_of_coaching_assignments,
    },
    {
      componentType: "input",
      type: "text",
      label: "Current number of assignments",
      helperText:
        errors.current_number_of_assignments &&
        "Please enter a Current Number of Assignments",
      name: "current_number_of_assignments",
      placeholder: "Current number of assignments",
      handleChange: handleInputChange,
      value: current_number_of_assignments,
      disabled: true,
    },
    {
      componentType: "input",
      type: "text",
      label: "Current capacity",
      helperText: errors.current_capacity && "Please enter a Current Capacity",
      name: "current_capacity",
      placeholder: "Current capacity",
      handleChange: handleInputChange,
      value: current_capacity,
      disabled: true,
    },
    {
      componentType: "select",
      label: "Are you currently available to take on new assignments?",
      helperText:
        errors &&
        errors.available_to_take_new_assignments &&
        "Please Yes or No",
      name: "available_to_take_new_assignments",
      value: available_to_take_new_assignments,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date available from",
      name: "date_available_from",
      value: date_available_from,
      handleChange: handleInputChange,
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date available until",
      name: "date_available_until",
      value: date_available_until,
      handleChange: handleInputChange,
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
  }, [errors]);

  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}
